import { render, staticRenderFns } from "./EditarRepartidor.vue?vue&type=template&id=ef1e143a&"
import script from "./EditarRepartidor.vue?vue&type=script&lang=js&"
export * from "./EditarRepartidor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports